import './App.css';
import '@tabler/core/dist/css/tabler.min.css';
import {ToastContainer} from "react-toastify";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Layout from "./Components/Default/Layout";

import {Events} from "./Pages/Events";
import {Event} from "./Pages/Event";
import {System} from "./Pages/System";

function App() {
  return (
      <Router>
        <ToastContainer closeOnClick />
        <Routes>
          <Route path="/" element={<Layout/>}>
            <Route path="/" element={<Events/>} />
            <Route path="/event/:eventID" element={<Event/>} />
            <Route path="/settings" element={<System/>} />
          </Route>
        </Routes>
      </Router>
  );
}

export default App;
